import{a as t}from"./chunk-RAAYCPUM.js";function a(...n){return t(c,n)}function c(n,r){let o={};for(let e of r)e in n&&(o[e]=n[e]);return o}export{a};
